import React from "react";
import styled from "styled-components";
import ReactTelephoneInput from "react-telephone-input/lib/ReactTelephoneInput";
import flags from "./assets/flags.png";
import arrow from "./assets/down-arrow.svg";

import "./style.css";

import { Error } from "../../service";

const InputField = styled.input`
  outline: none;
  appearance: none;
  border-radius: 2px;
  height: 3rem;
  font-family: CircularStd-Book;
  padding: 0.5rem;
  border: 1px solid #dcdcdc;
  display: block;
  width: 100%;
  box-sizing: border-box;
  &:focus {
    border-color: #c7c7c7;
  }
  ${({ isInvalid }) =>
    isInvalid &&
    `
    border-color: #E7040F;
  `};
  ${({ arrowIcon }) =>
    arrowIcon &&
    `
  background: url(${arrow}) 95% 15px;
  background-size: 20px 20px;
  background-repeat: no-repeat;
  background-clip: padding-box;
  cursor:pointer;

`};
`;

/* export default ({ error, ...props }) => (
  <div>
    <Input isInvalid={!!error} {...props} />
    {error && <Error>{error}</Error>}
  </div>
);
*/

const Input = ({ error, ...props }) => (
  <div className=" flex">
    <InputField isInvalid={!!error} {...props} />
    {error && <Error>{error}</Error>}
  </div>
);

Input.PhoneInput = ({ error, ...props }) => (
  <React.Fragment>
    <ReactTelephoneInput
      className="w-100 db"
      defaultCountry="us"
      flagsImagePath={flags}
      {...props}
    />
    {error && <Error>{error}</Error>}
  </React.Fragment>
);

export default Input;



// WEBPACK FOOTER //
// ./src/components/generic/form/native/Input/index.js